import DebugConsole from './debug/debug-console';

(function ($) {
  $.shopgate = $.shopgate || {};

  var categoryJSONLoaded = false;
  var categoryNavigationCategories = null;
  var saleNavigationAdded = false;

  /*****************************************************
   * THE CDN JSON LOADER - call it as early as possible
   * **************************************************/

  /**
   * This script loads category JSON from the CDN
   * @param  {Object} options The script options
   * @param  {String} options.categoryJSONUrl [optional] The url to the category JSON files
   * @param  {Number} [options.timeout] The timeout for the fallback loader
   * @param  {Number} [options.categoryNavigationFallback] Fallback data which is used if there was no categoryJSON loaded
   */
  $.shopgate.categoryNavigationLoader = function (options) {
    var defaults     = {
          categoryJSONUrl: '',
          timeout: 5000,
          categoryNavigationFallback: null
        },
        waitInterval = null;

    options = options || {};
    options = $.extend({}, defaults, options);

    // load json data from amazon
    loadCategoryJSONData();

    $(document).ready(function () {
      var waited = 0;

      // check if JSON has loaded and category data is present
      waitInterval = window.setInterval(function () {
        waited += 100;

        if (waited > options.timeout) {
          loadCategoryJSONFallback();
        }

        // json code is loaded and the variable contains data
        if (categoryJSONLoaded && window.tabletCategories) {
          categoryNavigationCategories = window.tabletCategories;
          clearWaitInterval();
        }
      }, 100);
    });

    function clearWaitInterval() {
      window.clearInterval(waitInterval);
    }

    /**
     * Loads a fallback datastructure for the category navigation if it wasn't able to load JSON from the CDN
     */
    function loadCategoryJSONFallback() {
      if (options.categoryNavigationFallback) {
        // use the same global variable as defined in the category JSON file
        window.tabletCategories = options.categoryNavigationFallback;
        categoryJSONLoaded = true;

        //	debugConsole.warn('CategoryNavigationLoader: fallback used');
      } else {
        //	debugConsole.warn('CategoryNavigationLoader: fallback not found');
      }

      //debugConsole.timeEnd('loadCategoryJSONData');
      //debugConsole.groupEnd('loadCategoryJSONData');
      clearWaitInterval();
    }

    /**
     * Loads JSON data from the CDN by a dynamically created script tag
     */
    function loadCategoryJSONData() {
      //debugConsole.group('loadCategoryJSONData');
      //debugConsole.time('loadCategoryJSONData');

      var head   = document.getElementsByTagName("head")[0],
          script = document.createElement("script");

      script.type = "text/javascript";
      script.src = options.categoryJSONUrl;

      // register a listener to the load event of the script tag
      script.onload = function () {
        onCategoryJSONLoaded();
      };

      scriptTagLoadFix(script, onCategoryJSONLoaded);

      // add the script to the document
      head.appendChild(script);

      /**
       * Workaround for browsers with bad event support on script tags
       * @param  {Object}   scriptElement Reference to the script tag that loads the JSON file
       * @param  {Function} callback      The function that is called when the JSON file is loaded
       */
      function scriptTagLoadFix(scriptElement, callback) {
        if (typeof scriptElement.readyState != 'undefined') {
          if (scriptElement.readyState == "loaded" || scriptElement.readyState == "completed") {
            onCategoryJSONLoaded();
          } else {
            window.setTimeout(function () {
              scriptTagLoadFix(scriptElement, callback);
            }, 100);
          }
        }
      }

      /**
       * This callback fires if the json file is loaded
       */
      function onCategoryJSONLoaded() {
        categoryJSONLoaded = true;
        /*
         debugConsole.info('JSON loaded from CDN');
         debugConsole.timeEnd('loadCategoryJSONData');
         debugConsole.groupEnd('loadCategoryJSONData');
         */
      }
    }
  };

  /*****************************************************
   * The jQuery plugin to process the category navigation data
   * **************************************************/

  /**
   * This plugin precesses the category navigation data for the UI.
   * It provides events for initialization and categroy data requests.
   * @param  {Object} options The script options
   * @param  {string} [options.categoryURL] The base url to create a category link
   * @param  {string} [options.mode] Determines the datastructure of the initialization event.
   *                                 'flat' creates an array with an entry for each category level,
   *                                 'tree' creates an object that represents the category tree in it's initial state
   * @param  {Array}  [selectedCategories]
   */
  $.fn.shopgateCategoryNavigation = function (options, selectedCategories) {
    "use strict";

    // selectedOptions is passed as the first parameter
    if (!selectedCategories && Array.isArray(options)) {
      selectedCategories = options;
      options = {};
    }

    // No arguments were passed - contine with an empty array
    if (!Array.isArray(selectedCategories)) {
      selectedCategories = [];
    }

    var defaults     = {
          categoryURL: '',
          showAllSuffix: 'all',
          mode: 'tree',
          timeout: 6000,
          addShowAllEntries: true,
          showAllEntryName: 'Alle anzeigen',
          debug: false,
          saleEntryName: 'ON SALE',
          addSaleCategory: false
        },
        dataMapping  = {
          name: 'n',
          children: 'c',
          number: 'i'
        },
        debugConsole = new DebugConsole();

    options = options || {};
    options = $.extend({}, defaults, options);

    debugConsole.group('categoryNavigationInit');
    debugConsole.time('categoryNavigationInit');

    return this.each(function () {
      var that                        = $(this),
          rootCategory                = {},
          categoryCache               = {},
          recentlyRequestedCategories = [],
          initResult                  = null,
          waitInterval                = null,
          waited                      = 0;

      $(document).ready(function () {
        // inform the UI that it will receive new category data soon
        that.trigger('shopgate.categoryNavigation.onBeforeInit');

        // wait till the JSON loader has downloaded the data
        waitInterval = window.setInterval(function () {
          waited += 100;

          // trigger a timeout if the JSON loader hasn't downloaded the data in a specific timeframe
          if (waited > options.timeout) {
            that.trigger('shopgate.categoryNavigation.onInitTimeout');
            clearWaitInterval();
          }

          // JSON code is loaded and the variable contains data
          if (categoryJSONLoaded && categoryNavigationCategories) {
            if (options.addSaleCategory && !saleNavigationAdded) {
              let fakeNumber = bin2hex(Date.now());

              categoryNavigationCategories.unshift({
                id: '0',
                i: fakeNumber,
                is_parent: false,
                is_show_all: false,
                is_sale: true,
                n: options.saleEntryName,
                path: [fakeNumber],
                requested_before: false,
              });

              saleNavigationAdded = true;
            }

            try {
              init();
            } catch (e) {
              debugConsole.error('categoryNavigationInit: interval exception - %s', e.message);
            }

            clearWaitInterval();
          }

          function clearWaitInterval() {
            debugConsole.timeEnd('categoryNavigationInit');
            debugConsole.groupEnd('categoryNavigationInit');
            countCategories();
            window.clearInterval(waitInterval);
          }

        }, 100);
      });

      /**
       * Initialize the category plugin
       * @return {Object|Array} The created data
       */
      function init() {
        // fake a root category
        rootCategory[dataMapping.name] = '';
        rootCategory[dataMapping.number] = bin2hex(Date.now());
        rootCategory[dataMapping.children] = categoryNavigationCategories;
        rootCategory.path = null;

        // add an event listener for the UI to request new category data
        that.bind('shopgate.categoryNavigation.getCategoryByCategoryNumber', function (e, categoryNumber) {
          that.trigger('shopgate.categoryNavigation.onCategoryUpdate', [getSubcategoriesForCategoryNumber(categoryNumber)]);
        });

        // add an event listener for the UI to requests a reinitialization for the category tree
        that.bind('shopgate.categoryNavigation.reInitCategoryNavigation', function (e) {
          reInit(true);
        });

        that.bind('shopgate.categoryNavigation.countCategories', function (e) {
          countCategories();
        });

        return reInit();
      }

      /**
       * Reinits the category navigation plugin. The UI will recieve a new onInit event
       * @param {boolean} resetRequestedStatus If set to TRUE the requested_before state of the cached categories will be resetted
       */
      function reInit(resetRequestedStatus) {
        var initResult = null;

        // reset the requested_before state on cached categories
        if (resetRequestedStatus) {
          for (var cachedCategoryIndex in categoryCache) {
            var cachedCategory = categoryCache[cachedCategoryIndex];
            cachedCategory.requested_before = false;
          }
        }

        // cache the selected categories
        cacheCategoriesFromCategoryPath(selectedCategories);

        if (options.mode == 'tree') {
          // pass no path so that we get the rootcategory as current category always (category-navigation-tree script is not working correctly)
          initResult = initTree();
        } else {
          initResult = initFlat();
        }

        // trigger the onInit event to the UI
        that.trigger('shopgate.categoryNavigation.onInit', [initResult]);

        // update the requested_before state
        processRequestedCategories();
        getCurrentBreadcrumb(options.debug);
      }

      /**
       * Initializes the category plugin in tree mode. this is an object that represents the current category path
       * @return {Object} The categories
       */
      function initTree(categoriesPath) {
        categoriesPath = categoriesPath || [];
        debugConsole.group('categoryNavigationInitTree');
        debugConsole.time('categoryNavigationInitTree');

        /**
         * NOTE: the navigation funktionailty is not working as expected.. category-navigation-tree script is not able to building the path from a current selected category,
         * it is only able to build a navigation from the rootCategory
         *    TODO enhance the category-navigation-tree
         */
        var localRootCategory = getCategoryFromCache(rootCategory[dataMapping.number]);
        var currentSelectedCategory = localRootCategory;
        var currentCategoryId = categoriesPath.slice(-1)[0];

        if (selectedCategories.length && currentCategoryId && categoryCache[currentCategoryId]) {

          currentSelectedCategory = getCategoryFromCache(currentCategoryId);
          currentCategoryId = categoriesPath.slice(-1)[0];

          // if we are in a child category without which has no subcategories itself, we want the parent category to be current active one
          if (!Array.isArray(currentSelectedCategory.category.subcategories) && currentCategoryId && categoryCache[currentCategoryId]) {
            currentSelectedCategory = getCategoryFromCache(categoriesPath.slice(-2)[0]);
          }
        }

        debugConsole.timeEnd('categoryNavigationInitTree');
        debugConsole.groupEnd('categoryNavigationInitTree');

        return currentSelectedCategory;
      }

      /**
       * Initializes the category plugin in flat mode. this is an array with all steps in the inital category path
       * @return {Array} The categories
       */
      function initFlat() {
        debugConsole.group('categoryNavigationInitFlat');
        debugConsole.time('categoryNavigationInitFlat');

        var categories = [];

        // push the root category
        categories.push(getCategoryFromCache(rootCategory[dataMapping.number]));

        // push the categories
        for (var selectedCategoriesIndex = 0; selectedCategoriesIndex < selectedCategories.length; selectedCategoriesIndex++) {
          var nextCategory = clone(getCategoryFromCache(selectedCategories[selectedCategoriesIndex]));

          if (!nextCategory) {
            break;
          }

          if (Array.isArray(categories[categories.length - 1].category.path) && categories[categories.length - 1].category.path.length > 0) {
            var previousCategoryPath = categories[categories.length - 1].category.path;
            // copy the category number of the current category to the selected path array of the previous category
            previousCategoryPath.reverse();
            previousCategoryPath.push(nextCategory.category.number);
            previousCategoryPath.reverse();
          }

          categories.push(nextCategory);
        }

        // update the selected categories to the current state
        // !!! ATTENTION !!! this has to be done before she first slice operation
        selectedCategories = categories.slice(categories.length - 1, categories.length)[0].category.path;

        // only put the last category on the stack if it has subcategories
        if (!Array.isArray(categories[categories.length - 1].category.subcategories) || Array.isArray(categories[categories.length - 1].category.subcategories.length === 0)) {
          categories = categories.slice(0, categories.length - 1);
        }

        debugConsole.timeEnd('categoryNavigationInitFlat');
        debugConsole.groupEnd('categoryNavigationInitFlat');

        return categories;
      }

      /**
       * Creates a list of subcategories for a passed categoryNumber
       * @param  {string} categoryNumber A category number
       * @return {Object} Data for the requested category and its subcategories
       */
      function getSubcategoriesForCategoryNumber(categoryNumber) {
        categoryNumber = decodeURIComponent(categoryNumber.replace(new RegExp("\\Ic4aM6", "g"), '%'));
        debugConsole.group('categoryNavigationGetCategory');
        debugConsole.time('categoryNavigationGetCategory');

        var category = getCategoryFromCache(categoryNumber);
        // if the requested category was found and it has subcategories we put all categories
        // on the cache
        if (category && category.category.subcategories) {
          cacheCategoriesFromCategoryPath(category.category.path);
        }

        // get the category from cache again because it may be modified through the cache process
        category = getCategoryFromCache(categoryNumber);

        processRequestedCategories();

        debugConsole.timeEnd('categoryNavigationGetCategory');
        debugConsole.groupEnd('categoryNavigationGetCategory');

        selectedCategories = category.category.path;

        getCurrentBreadcrumb(options.debug);

        return category;
      }

      /**
       * Counts the categories of the current category list
       * @return {[type]} [description]
       */
      function countCategories() {
        var counter = 0;
        debugConsole.group('categoryNavigationCountCategories');
        debugConsole.time('categoryNavigationCountCategories');

        // start with the root category
        countSubcategories(rootCategory);

        debugConsole.timeEnd('categoryNavigationCountCategories');
        debugConsole.groupEnd('categoryNavigationCountCategories');

        debugConsole.info('countCategories: %s categories in this shop', counter);

        return counter;

        /**
         * Counts the subcategories of a category
         * @param {Object} category A category from the JSON
         */
        function countSubcategories(category) {
          if (Array.isArray(category[dataMapping.children])) {

            counter = counter + category[dataMapping.children].length;

            // search for subcategories in this subcategory
            for (var subcategoryIndex = 0; subcategoryIndex < category[dataMapping.children].length; subcategoryIndex++) {
              var subcategory = category[dataMapping.children][subcategoryIndex];
              // recursion :-D
              if (subcategory[dataMapping.children]) {
                countSubcategories(subcategory);
              }
            }
          }
        }
      }

      /**
       * Creates a breadcrumb and echoes it on the console
       * @param  {boolean} withObjects If set to TRUE the category objects will be echoed
       * @return {Array} If withObjects is set to TRUE an array with the breadcrumb objects
       */
      function getCurrentBreadcrumb(withObjects) {
        var breadcrumb        = 'Home',
            breadcrumbObjects = [];

        for (var selectedCategoryIndex = 0; selectedCategoryIndex < selectedCategories.length; selectedCategoryIndex++) {
          if (!categoryCache[selectedCategories[selectedCategoryIndex]]) {
            break;
          }

          var category = getCategoryFromCache(selectedCategories[selectedCategoryIndex]);
          breadcrumb += ' > ' + category.category.name + '';

          if (withObjects) {
            breadcrumbObjects.push(category);
          }
        }

        debugConsole.info("selectedCategories: %s", breadcrumb.trim());

        if (withObjects) {
          debugConsole.log(breadcrumbObjects);
          return breadcrumbObjects;
        }

        return [];
      }

      /**
       * Processes the recentlyRequestedCategories after cache entries were passed to the UI
       */
      function processRequestedCategories() {
        var alreadyRequestedCounter = 0;
        // flag the recently used cache entries as requested
        for (var requestedCategoryIndex = 0; requestedCategoryIndex < recentlyRequestedCategories.length; requestedCategoryIndex++) {
          var requestedCategory = recentlyRequestedCategories[requestedCategoryIndex];
          if (requestedCategory.requested_before === true) {
            alreadyRequestedCounter++;
          }

          requestedCategory.requested_before = true;
        }
        // reset the requested categories
        recentlyRequestedCategories = [];

        if (alreadyRequestedCounter) {
          debugConsole.info('processRequestedCategories: %s entries were requested before', alreadyRequestedCounter);
        }
      }

      /**
       * Collects enrichted category data from the category cache
       * @param  {String} categoryNumber A category number
       * @return {Object} The category data
       */
      function getCategoryFromCache(categoryNumber) {
        // first check if the requested category is cached
        if (!categoryCache[categoryNumber]) {
          return null;
        }

        // note the requested category in the recently requested categories
        recentlyRequestedCategories.push(categoryCache[categoryNumber]);

        // get the category from the cache and begin the enrichment of the data
        var requestedCategory = categoryCache[categoryNumber];
        var categoryDataForUI = { category: {} };

        categoryDataForUI.category.name = requestedCategory[dataMapping.name];
        categoryDataForUI.category.number = requestedCategory[dataMapping.number];
        categoryDataForUI.category.path = requestedCategory.path;
        categoryDataForUI.category.is_root = requestedCategory[dataMapping.number] == rootCategory[dataMapping.number] ? true : false;
        categoryDataForUI.category.requested_before = requestedCategory.requested_before;
        categoryDataForUI.category.parent = null;
        categoryDataForUI.category.is_show_all = requestedCategory.is_show_all;
        categoryDataForUI.category.is_sale = requestedCategory.is_sale;
        categoryDataForUI.category.url = '';
        categoryDataForUI.category.url_enabled = false;
        categoryDataForUI.category.subcategories = [];

        // determine the parent category of the requested category
        if (Array.isArray(requestedCategory.path) && requestedCategory.path.length) {
          // get the category number of the category from its category path
          var tmpParentCategory = requestedCategory.path.slice(requestedCategory.path.length - 2, requestedCategory.path.length - 1)[0];

          if (!tmpParentCategory) {
            // nothing found in the category path. so it must be a subcategory of the root category
            tmpParentCategory = rootCategory[dataMapping.number];
          }

          // add the category number of the parent category to the requested category
          categoryDataForUI.category.parent = tmpParentCategory;
        }

        // set the category url now that we know the parent category of this subcategory
        categoryDataForUI.category.url = getCategoryURL(categoryDataForUI);

        if (Array.isArray(requestedCategory[dataMapping.children])) {
          // the requested category has subcategories. so we append some basic informations about them
          for (var subcategoryIndex = 0; subcategoryIndex < requestedCategory[dataMapping.children].length; subcategoryIndex++) {
            var subcategory = requestedCategory[dataMapping.children][subcategoryIndex];
            var subcategoryDataForUI = { category: {} };

            subcategoryDataForUI.category.name = subcategory[dataMapping.name];
            subcategoryDataForUI.category.number = subcategory[dataMapping.number];
            subcategoryDataForUI.category.path = subcategory.path;
            subcategoryDataForUI.category.is_root = false;
            subcategoryDataForUI.category.requested_before = subcategory.requested_before;
            subcategoryDataForUI.category.parent = categoryDataForUI.category.number;
            subcategoryDataForUI.category.is_show_all = subcategory.is_show_all;
            subcategoryDataForUI.category.is_sale = subcategory.is_sale;
            subcategoryDataForUI.category.url = getCategoryURL(subcategoryDataForUI);
            subcategoryDataForUI.category.url_enabled = !subcategory[dataMapping.children] ? true : false;
            subcategoryDataForUI.category.has_children = subcategory[dataMapping.children] ? true : false;

            // Push the subcategory to the category
            categoryDataForUI.category.subcategories.push(subcategoryDataForUI);
          }
        }

        // null the subcategory attribute if it doesn't contain entries. so it's easier to check the subcategory status.
        if (categoryDataForUI.category.subcategories.length === 0) {
          categoryDataForUI.category.subcategories = null;
          categoryDataForUI.category.url_enabled = true;
        }

        return categoryDataForUI;
      }

      /**
       * Creates a url to a regular category or a faked "show all" category
       * @param {Object} category A category in the cached category style
       * @return {String} The URL on success. An empty string an failure
       */
      function getCategoryURL(category) {
        if (!category || !category.category) {
          return '';
        }

        var parentCategory = categoryCache[category.category.parent];

        if (category.category.is_show_all) {
          return options.categoryURL + '/' + bin2hex(parentCategory[dataMapping.number]) + '/' + options.showAllSuffix;
        }

        if (category.category.is_sale) {
          return options.categoryURL + '/sale';
        }

        return options.categoryURL + '/' + bin2hex(category.category.number);
      }

      /**
       * Caches all categories and their subgategories on a specified path through the category tree
       * @param  {Array} categoryPath The path through the category tree for the currently relevant category
       */
      function cacheCategoriesFromCategoryPath(categoryPath) {
        var currentCategory = rootCategory;	// the currently inspected category
        var cachedCategories = [];			// the categories that has been cached during the current iteration

        // first we check if the root category must be inspected. it will not appear in the catetegoryPath

        // cache the root category if it have not done yet
        if (!categoryCache[currentCategory[dataMapping.number]]) {
          cacheCategory(currentCategory, null);
        }

        // put the root category to the cachedCategories array
        cachedCategories.push(categoryCache[rootCategory[dataMapping.number]]);

        // iterate through the category path
        for (var categoryPathIndex = 0; categoryPathIndex < categoryPath.length; categoryPathIndex++) {
          if (Array.isArray(currentCategory[dataMapping.children])) {
            // iterate through the subcategories of the currently inspected category
            for (var currentSubcategoryIndex = 0; currentSubcategoryIndex < currentCategory[dataMapping.children].length; currentSubcategoryIndex++) {
              var currentSubcategory = currentCategory[dataMapping.children][currentSubcategoryIndex];

              // we found the subcategory from the currenty categoryPathIndex and will put it in the cache if it hasn't already been done
              if (currentSubcategory[dataMapping.number] == categoryPath[categoryPathIndex]) {
                // prepare the data for the next iteration. then we will inspect the subcategories of the current category
                currentCategory = currentSubcategory;

                // cache the category if necessary
                if (!categoryCache[currentSubcategory[dataMapping.number]]) {
                  cacheCategory(currentCategory, categoryPath.slice(0, categoryPathIndex + 1));
                }

                // put the current category to the cachedCategories array
                cachedCategories.push(categoryCache[currentSubcategory[dataMapping.number]]);
                break;
              }
            }
          }
        }

        // now we will create cache entries for the subcategories of the just cached categories
        for (var cachedCategoryIndex = 0; cachedCategoryIndex < cachedCategories.length; cachedCategoryIndex++) {
          var cachedCategory = cachedCategories[cachedCategoryIndex];
          var cachedSubcategories = cachedCategory[dataMapping.children];

          if (Array.isArray(cachedSubcategories)) {
            // smuggle in a fake "show all" category if requested
            if (options.addShowAllEntries && !cachedCategory.is_parent) {
              var showAllCategory = {};
              showAllCategory[dataMapping.number] = 'show_all_' + cachedCategory[dataMapping.number];
              showAllCategory[dataMapping.name] = options.showAllEntryName;

              showAllCategory.is_show_all = true;

              if (!categoryCache[showAllCategory[dataMapping.number]]) {
                cachedSubcategories.unshift(showAllCategory);
              }
            }

            if (options.addSaleCategory && !cachedCategory.is_parent) {
              var saleCategory = {};

              saleCategory[dataMapping.number] = 'sale_' + cachedCategory[dataMapping.number];
              saleCategory[dataMapping.name] = options.saleEntryName;
              saleCategory.is_sale = true;

              if (!categoryCache[saleCategory[dataMapping.number]]) {
                cachedSubcategories.unshift(saleCategory);
              }
            }

            // this category has subcategories
            for (var cachedSubcategoryIndex = 0; cachedSubcategoryIndex < cachedSubcategories.length; cachedSubcategoryIndex++) {
              var cachedSubcategory = cachedSubcategories[cachedSubcategoryIndex],
                  subcategoryPath   = null;

              // check if we already have cache data for the current subcategory
              if (!categoryCache[cachedSubcategory[dataMapping.number]]) {
                subcategoryPath = clone(cachedCategory.path);

                // determine the category path of the current subcategory
                if (!subcategoryPath) {
                  subcategoryPath = [cachedSubcategory[dataMapping.number]];
                } else {
                  subcategoryPath.push(cachedSubcategory[dataMapping.number]);
                }

                // put it into the cache
                cacheCategory(cachedSubcategory, subcategoryPath);
              }
            }
          }
        }

        debugConsole.info('cacheUpdate: %s entries in cache', Object.keys(categoryCache).length);

        /**
         * Puts a category into the category cache
         * @param  {Object} category        The category that should be cached
         * @param  {Array}    categoryPath    The path of the current category in the category tree
         * @return {Object} The cached category
         */
        function cacheCategory(category, categoryPath) {
          category.is_parent = !categoryPath ? true : false;
          category.path = categoryPath ? categoryPath : [];
          category.requested_before = false;
          category.is_show_all = typeof category.is_show_all !== 'undefined' ? category.is_show_all : false;
          category.is_sale = typeof category.is_sale !== 'undefined' ? category.is_sale : false;

          // put it into the cache
          categoryCache[category[dataMapping.number]] = category;

          return categoryCache[category[dataMapping.number]];
        }
      }
    });
  };

  function bin2hex(s) {
    s = unescape(encodeURIComponent(s));
    var i, f = 0, a = [];
    s += '';
    f = s.length;
    for (i = 0; i < f; i++) {
      a[i] = s.charCodeAt(i).toString(16).replace(/^([\da-f])$/, "0$1");
    }
    return a.join('');
  }

  function clone(object) {
    if (object === null || typeof(object) != 'object') {
      return object;
    }

    var temp = object.constructor();

    for (var key in object) {
      temp[key] = clone(object[key]);
    }

    return temp;
  }
})(jQuery);


// WEBPACK FOOTER //
// ./Library/1.0/common/jquery.shopgate-category-navigation.js